import { render, staticRenderFns } from "./SimpleBlock.vue?vue&type=template&id=1e05b8a9&scoped=true"
import script from "./SimpleBlock.vue?vue&type=script&lang=js"
export * from "./SimpleBlock.vue?vue&type=script&lang=js"
import style0 from "./SimpleBlock.vue?vue&type=style&index=0&id=1e05b8a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../common/temp/node_modules/.pnpm/vue-loader@15.11.1_qty7iymlffgpukvncpluvycwfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05b8a9",
  null
  
)

export default component.exports